var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-overlay" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.onCancel,
            expression: "onCancel",
          },
        ],
        staticClass: "modal-box",
      },
      [
        _c("div", { staticClass: "icon-wrapper" }, [
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 24 24",
                width: "64",
                height: "64",
                stroke: "#f39c12",
                "stroke-width": "2",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
              _vm._v(" "),
              _c("line", { attrs: { x1: "12", y1: "8", x2: "12", y2: "12" } }),
              _vm._v(" "),
              _c("circle", { attrs: { cx: "12", cy: "16", r: "1" } }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.trialWillEnd"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "description" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.trialEndConfirmDescription")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-group" },
          [
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("common.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.onConfirm } },
              [_vm._v(_vm._s(_vm.$t("message.confirmAndContinue")))]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }